// extracted by mini-css-extract-plugin
export var contrastLow = "_2l-1";
export var externalLink = "_2l-2";
export var externalLinkIcon = "_2l-3";
export var link = "_2l-0";
export var linkLabel = "_2l-4";